'use strict';

import $ from 'jquery';
import 'jquery-match-height';
import HighlightsCarousel from '../../molecules/highlights-carousel/highlights-carousel';

export default class HighlightsBanner {
  constructor() {
    let $highlightsBanner = $('.highlights-banner__item');
    
    new HighlightsCarousel();

    $highlightsBanner.matchHeight();
  }
}
